import { gql } from '@apollo/client';

export enum AssignType {
    DIRECT = 0,    // 直接指派
    BY_STOP = 1,   // 按Stop序号（序列）
    BY_ZIPCODE = 2, // 按邮编
    BY_MAP = 3,    // 按区域（地图圈选）
    BY_ALGORITHM = 4, // 算法分单
}

export interface DriverAddressInput {
    streetAddress?: string | null;
    unit?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    latitude?: number | null;
    longitude?: number | null;
}

export interface AssignTaskInput {
    dspTaskId?: number | null;
    areaId?: number | null;
    areaName?: string | null;
    split?: boolean | null;
    dspId?: number | null;
    dspName?: string | null;
    assignType?: number | null;
    assignTypeDetail?: string[] | null;
    driverId?: number | null;
    driverName?: string | null;
    startAddress?: DriverAddressInput | null;
    endAddress?: DriverAddressInput | null;
    parcelCount?: number | null;
    orderIds?: number[] | null;
    childTaskList?: AssignTaskInput[] | null;
    algoRecordId?: number | null;
}

export interface AssignDriversRequestInput {
    warehouseId: number;
    taskDate: string;
    taskList: AssignTaskInput[];
}

export interface AssignDriversResponse {
    assignDrivers: boolean;
}

export interface AssignDriversVariables {
    request: AssignDriversRequestInput;
}

export const ASSIGN_DRIVERS = gql`
    mutation AssignDrivers($request: AssignDriversRequestInput!) {
        assignDrivers(request: $request)
    }
`;